export default {
  'attacks.create.targets.kubernetes.kubernetes_high_level_filters.invalid_chao_client_version.message':
    'Please upgrade your chao client version to {{version}} to use label selection',
  'attacks.create.container_selection_warning.message':
    'Network experiments targeting one container will impact all containers within the same pod.',
  'attacks.details.container_selection_info.message':
    'Network experiments targeting one container impacts all containers within the same pod.',
  'attacks.details.stage.warning.message':
    'In the event of a LostCommunication error, the Gremlin Agent will trigger its dead-man switch and cease all experiments.',
  'attacks.details.stage.passed_with_warning.message':
    'Experiment applied impact successfully, but terminated before its defined length elapsed. This may be an expected outcome. Refer to the executions log for more details.',
  'attacks.details.infra_attack_contents.alert_message':
    'We have turned off the visualization due to having more than 10 targets.',
  'attacks.schedule_experiment': 'Schedule Experiment',
  'attacks.create_new_experiment': 'Create a new experiment.',
  'attacks.create_new_experiment.description':
    'An experiment is a way of creating or injecting stress and/or failure in some part of a system, such as causing networking problems or exhausting resources up to their limits. This is also known as fault injection. Experiments are the means by which we perform Chaos Engineering, and how we identify failure modes in systems.',
  'attacks.list.ilfi_attack_row_targets.tooltip.overflow.label':
    '...{{overflowCount}} more',
  'attacks.create.infra_impact.arguments.unsupported_by_os.warning.message':
    'This argument is not supported for the following OS(s): {{unsupportedOSList}}'
}
